module.exports = __webpack_public_path__ + "img/arrow_left.1c36cc8d.png";